import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx';
import SaveIcon from '@material-ui/icons/Save';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';

import Button from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import CustomSelect from 'components/CustomSelect/CustomSelect.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

import WaitDialog from 'conten/components/WaitDialog.jsx';
import React from 'react';
import { connect } from 'react-redux';
import { OK } from 'config/general/Configuracion';

import DateRangeIcon from '@material-ui/icons/DateRange';

import CustomTextarea from 'components/CustomTextarea/CustomTextarea';

import TituloPagina2 from 'conten/components/TituloPagina2';
import Accordion from 'components/Accordion/Accordion';

import {
  dencriptarContenido,
} from 'conten/usuarios/UsuarioUtilidades';
import { addMessage } from 'conten/mensajes/MessagesActions';
import AplicarSeguridad from 'conten/components/AplicarSeguridad';

import { MonetizationOn } from '@material-ui/icons';
import { listarZonaActiva, guardarPlanZona, guardarPlan, listarPlanZona } from './PlanesActions';
import { LISTADO_PAGINACION } from 'config/general/Configuracion';

class PlanesAdministrar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      textoAlerta: 'Un momento por favor ...',
      paginacion: {
        limite: 10000,
        actual: 1,
        filtro: undefined,
        orden: "",
        sentido: "ASC",
      },
      planZona: {
        nombre: '',
        creador: 1,
        minutos_plan_zona: '',
        minutos_nuevo_plan_zona: '',
        idZonas: [],
        informacion: ''
      },
      plan: {
        plan_zona_id: '',
        nombre: '',
        plazo: '',
        valor: '',
        creador: 1,
        informacion: '',
        es_carro: null,
      },
      zonas: [],
    };
  }

  traerDatosServidor = () => {
    this.props.listarPlanZona(this.state.paginacion);

    this.props.listarZonaActiva((zonas) => {
      this.setState({ zonas });
    });
  };


  componentDidMount = () => {
    this.traerDatosServidor();

  };


  cambioContenidoPlanZona = (valor, campo) => {
    var planZona = this.state.planZona;
    planZona[campo] = valor;
    this.setState({ planZona: planZona });
    return true;
  };


  cambioContenidoPlan = (valor, campo) => {
    var plan = this.state.plan;
    plan[campo] = valor;
    this.setState({ plan: plan });
    return true;
  };

  cambioActivo = () => {
    this.setState((prevState) => ({
      usuario: { ...prevState.usuario, activo: !prevState.usuario.activo },
    }));
  };

  validarContenidos = () => {
    this.procesarServidorClave();
  };

  validarContenidosPlanZona = () => {

    const { planZona } = this.state;

    // Validar el nombre
    if (!planZona.nombre || planZona.nombre.trim() === "") {
      throw new Error("El nombre del plan zona es obligatorio.");
    }

    // Validar minutos_plan_zona
    if (!planZona.minutos_plan_zona || isNaN(planZona.minutos_plan_zona) || planZona.minutos_plan_zona <= 0) {
      throw new Error("Los minutos del plan zona deben ser un número mayor a 0.");
    }

    // Validar minutos_nuevo_plan_zona
    if (!planZona.minutos_nuevo_plan_zona || isNaN(planZona.minutos_nuevo_plan_zona) || planZona.minutos_nuevo_plan_zona <= 0) {
      throw new Error("Los minutos para renovar el plan zona deben ser un número mayor a 0.");
    }

    // Validar creador
    if (!planZona.creador || isNaN(planZona.creador)) {
      throw new Error("El identificador del creador es obligatorio y debe ser un número.");
    }

    // Validar idZonas
    if (!planZona.idZonas || !Array.isArray(planZona.idZonas) || planZona.idZonas.length === 0) {
      throw new Error("Debe seleccionar al menos una zona.");
    }

    // Si pasa todas las validaciones, no hace nada (o puedes devolver un true)
    return true;

  };
  validarContenidosPlan = () => {

    const { plan } = this.state;

    // Validar el nombre
    if (!plan.nombre || plan.nombre.trim() === "") {
      throw new Error("El nombre del plan es obligatorio.");
    }
    // Validar la vigencia
    if (!plan.plazo || plan.plazo.trim() === "") {
      throw new Error("La vigencia debe ser mayor a 0.");
    }
    // Validar el valor
    if (!plan.valor || plan.valor.trim() === "") {
      throw new Error("El valor del plan debe ser mayor a 0.");
    }

    // Validar el valor
    if (!plan.plan_zona_id || plan.plan_zona_id === null) {
      throw new Error("El plan debe tener asignado un conjunto de zonas.");
    }
    // Validar el valor
    if (!plan.es_carro || plan.es_carro === null) {
      throw new Error("Debe elegir el tipo de plan.");
    }




    // Si pasa todas las validaciones, no hace nada (o puedes devolver un true)
    return true;

  };


  resultadoGrabar = (resultado, data) => {
    if (resultado === OK) {
      this.props.history.goBack();
    }
  };


  guardarCambiosPlanZona = () => {
    try {
      this.validarContenidosPlanZona();
      this.props.guardarPlanZona(this.state.planZona, this.resultadoGrabar);
    } catch (error) {
      // Manejar errores de validación
      this.abrirAlerta(error.message, "error");
    }
  };
  guardarCambiosPlan = () => {
    try {
      this.validarContenidosPlan();
      this.props.guardarPlan(this.state.plan, this.resultadoGrabar);
    } catch (error) {
      // Manejar errores de validación
      this.abrirAlerta(error.message, "error");
    }
  };

  abrirAlerta = (text, contenidoTipo = 'error') => {
    this.props.addMessage({ variant: contenidoTipo, message: text + '' });
  };

  render() {
    const { classes, zonaActivaState, planZonaState } = this.props;
    const { zonas = [], paginacion = {}, isActivityIndicatorShown = false } =
      zonaActivaState || {};
    const { planZona = [] } =
      planZonaState || {};



    if (!paginacion || !zonas || !planZona) {
      return <div>Cargando...</div>;
    }
    return (
      <GridItem xs={12}>
        {isActivityIndicatorShown && (
          <WaitDialog text={this.state.textoAlerta} />
        )}
        <AplicarSeguridad />
        <Card>
          <CardHeader icon>
            <CardIcon
              style={{
                cursor: 'pointer',
              }}
              color='primary'
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              <b>{'Ver listado de planes'}</b>
              <DateRangeIcon />
            </CardIcon>
            <TituloPagina2
              texto='_____________'
              color='primary'
              classes={classes}
            />
          </CardHeader>

          <CardBody>
            <Accordion
              active={0}
              collapses={[
                {
                  title: 'Crear conjunto de zonas',
                  content: (
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText="* Nombre del conjunto de zonas"
                          id="planZonaNombre"
                          success
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: "planZonaNombre",
                            id: "planZonaNombre",
                            value: this.state.planZona.nombre,
                            onChange: (event) =>
                              this.cambioContenidoPlanZona(
                                event.target.value,
                                "nombre"
                              ),
                            endAdornment: (
                              <InputAdornment position="start">

                              </InputAdornment>
                            ),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText="* Minutos de gracia válidos en cada zona"
                          id="minutos_plan_zona"
                          success
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: "minutos_plan_zona",
                            id: "minutos_plan_zona",
                            value: this.state.planZona.minutos_plan_zona,
                            onChange: (event) =>
                              this.cambioContenidoPlanZona(
                                event.target.value,
                                "minutos_plan_zona"
                              ),
                            endAdornment: (
                              <InputAdornment position="start">
                                <DateRangeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText="* Minutos para renovar tiempo de gracia"
                          id="minutos_nuevo_plan_zona"
                          success
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: "minutos_nuevo_plan_zona",
                            id: "minutos_nuevo_plan_zona",
                            value: this.state.planZona.minutos_nuevo_plan_zona,
                            onChange: (event) =>
                              this.cambioContenidoPlanZona(
                                event.target.value,
                                "minutos_nuevo_plan_zona"
                              ),
                            endAdornment: (
                              <InputAdornment position="start">

                              </InputAdornment>
                            ),
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomSelect
                          key="zonas"
                          success
                          labelText="* Seleccione las zonas"
                          id="zonas"

                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: "idZonas",
                            id: "idZonas",
                            multiple: true,
                            value: this.state.planZona.idZonas,
                            onChange: (event) => {
                              const seleccion = Array.isArray(event.target.value) ?
                                event.target.value :
                                [event.target.value]

                              this.cambioContenidoPlanZona(seleccion, "idZonas");
                            },
                          }}
                          selectContent={zonas.map((zona) => (
                            <MenuItem key={zona.id} value={zona.id}>
                              {zona.nombre}
                            </MenuItem>
                          ))}

                        />

                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomTextarea
                          labelText="Información"
                          id="informacion"
                          success
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: this.state.planZona.informacion,
                            onChange: (event) =>
                              this.cambioContenidoPlanZona(
                                event.target.value,
                                "informacion"
                              ),
                          }}
                        />
                      </GridItem>


                      <GridItem xs={12} sm={6} md={6}>
                        <Button
                          type="button"
                          onClick={(e) => {
                            this.guardarCambiosPlanZona();
                            e.preventDefault();
                          }}
                          color="success"
                        >
                          <SaveIcon />
                          Guardar
                        </Button>
                      </GridItem>
                    </GridContainer>
                  ),
                },
                {
                  title: 'Crear nuevo plan',
                  content: (
                    <GridContainer>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText="* Nombre del plan"
                          id="planNombre"
                          success
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: "planNombre",
                            id: "planNombre",
                            value: this.state.plan.nombre,
                            onChange: (event) =>
                              this.cambioContenidoPlan(
                                event.target.value,
                                "nombre"
                              ),
                            endAdornment: (
                              <InputAdornment position="start">

                              </InputAdornment>
                            ),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText='* Vigencia del plan (En dias)'
                          id='plazo'
                          success
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: 'plazo',
                            id: 'plazo',
                            value: this.state.plan.plazo,
                            onChange: (event) =>
                              this.cambioContenidoPlan(
                                event.target.value,
                                'plazo'
                              ),
                            endAdornment: (
                              <InputAdornment position='start'>
                                <DateRangeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={6} md={6}>
                        <CustomInput
                          labelText='* Valor del plan'
                          id='valor'
                          success
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: 'valor',
                            id: 'valor',
                            value: this.state.plan.valor,
                            onChange: (event) =>
                              this.cambioContenidoPlan(
                                event.target.value,
                                'valor'
                              ),
                            endAdornment: (
                              <InputAdornment position='start'>
                                <MonetizationOn />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomSelect
                          key='plan_zona_id'
                          success
                          labelText="* Seleccione el plan de zona"
                          id='plan_zona_id'
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: 'plan_zona_id',
                            id: 'plan_zona_id',
                            value: this.state.plan.plan_zona_id,
                            onChange: (event) => {
                              const seleccion = event.target.value;
                              this.cambioContenidoPlan(seleccion, "plan_zona_id"); // Actualiza el estado con el ID seleccionado
                            },
                          }}
                          selectContent={planZona.map((planZona) => (
                            <MenuItem key={planZona.id} value={planZona.id}>
                              {planZona.nombre} {/* Muestra el nombre del plan de zona */}
                            </MenuItem>
                          ))}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <CustomTextarea
                          labelText='Información'
                          id='informacion'
                          success
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            value: this.state.plan.informacion,
                            onChange: (event) =>
                              this.cambioContenidoPlan(
                                event.target.value,
                                'informacion'
                              ),
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={6} md={6}>
                        <CustomSelect
                          key="tipoPlan"
                          success
                          labelText="* Seleccione el tipo de plan"
                          id="tipoPlan"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            name: "tipoPlan",
                            id: "tipoPlan",
                            value: this.state.plan.es_carro, // Muestra "carro" o "moto"
                            onChange: (event) => {
                              const seleccion = event.target.value;

                              this.cambioContenidoPlan(seleccion, "es_carro"); // Actualiza el estado con el ID seleccionado
                            },
                          }}
                          selectContent={[

                            <MenuItem key="carro" value='true'>
                              Carro
                            </MenuItem>,
                            <MenuItem key="moto" value='false'>
                              Moto
                            </MenuItem>,
                          ]}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <Button
                          type='button'
                          onClick={(e) => {
                            this.guardarCambiosPlan();
                            e.preventDefault();
                          }}
                          color='success'
                        >
                          <SaveIcon />
                          Guardar
                        </Button>
                      </GridItem>
                    </GridContainer>
                  ),
                },
              ]}
            />
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zonaActivaState: state.zonaActivaState,
    planZonaState: state.planZonaState,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    listarPlanZona: (paginacion) => dispatch(listarPlanZona(paginacion, () => { })),
    listarZonaActiva: (onSuccess) => dispatch(listarZonaActiva(onSuccess)),
    guardarPlan: (plan, onSuccess) =>
      dispatch(guardarPlan(plan, onSuccess)),
    addMessage: (content) => dispatch(addMessage(content)),
    guardarPlanZona: (planZona, onSuccess) =>
      dispatch(guardarPlanZona(planZona, onSuccess)),
  };

};

export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PlanesAdministrar)
);
